// FirmaEmisionFactura.jsx
import { useState } from 'react'
// import { ArrowLeft } from 'lucide-react'

export default function FirmaEmisionFactura({ document, totals, onBack, onEmit, isSubmitting }) {
  const [accepted, setAccepted] = useState(false)
  const receiver = document.document_receiver || {}

  const formatCLP = v =>
    v.toLocaleString('es-CL', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })

  const handleEmitClick = () => {
    if (!accepted) return
    onEmit()
  }

  return (
    <div className='space-y-6'>
      {/* <header className='flex items-center justify-between'>
        <button
          onClick={onBack}
          className='flex items-center gap-2 text-[#000033] hover:underline font-semibold'
        >
          <ArrowLeft size={18} /> Volver
        </button>
      </header> */}

      <section className='bg-white rounded-2xl shadow p-6 space-y-4'>
        <h1 className='text-2xl font-semibold text-center mb-2'>Firma y Emisión de Documentos</h1>
        <p className='text-sm text-gray-600 text-center'>
          Este es el último paso. Revisa el resumen de los documentos y firma con tu certificado
          digital para emitir al SII.
        </p>

        <div className='bg-gray-50 rounded-xl p-4 mt-4'>
          <h2 className='text-base font-semibold mb-3'>Resumen de Documentos</h2>
          <div className='grid grid-cols-1 md:grid-cols-3 gap-6 text-sm'>
            <div className='border-r border-gray-200 pr-4'>
              <div className='text-gray-500 font-medium uppercase text-[10px] mb-1'>
                Cantidad de Documentos
              </div>
              <div className='font-bold text-gray-800 text-lg'>1</div>
            </div>
            <div className='border-r border-gray-200 pr-4'>
              <div className='text-gray-500 font-medium uppercase text-[10px] mb-1'>Total Neto</div>
              <div className='font-bold text-xl text-[#000033]'>${formatCLP(totals.subtotal)}</div>
            </div>
            <div className='pl-2'>
              <div className='text-gray-500 font-medium uppercase text-[10px] mb-1'>Total</div>
              <div className='font-bold text-xl text-[#000033]'>${formatCLP(totals.total)}</div>
            </div>
          </div>

          <div className='mt-4 border rounded-lg bg-white p-4'>
            <div className='text-xs text-gray-500 font-medium uppercase mb-2'>Receptor</div>
            <div className='flex items-start justify-between text-sm'>
              <div>
                <div className='font-semibold text-gray-800'>
                  {receiver.business_name || 'Cliente sin nombre'}
                </div>
                <div className='text-gray-600 text-xs mt-1'>
                  {receiver.rut || '—'} ·{' '}
                  {document.dte_type?.code === '34' ? 'Factura Exenta' : 'Factura Electrónica'}
                </div>
                <div className='text-gray-400 text-[10px] mt-1'>
                  Fecha emisión: {document.date_issued || '—'}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='bg-gray-50 rounded-xl p-4 space-y-3'>
          <div className='flex items-start gap-3 text-sm'>
            <input
              type='checkbox'
              id='accept-emission'
              className='mt-1 w-4 h-4 cursor-pointer'
              checked={accepted}
              onChange={e => setAccepted(e.target.checked)}
            />
            <label
              htmlFor='accept-emission'
              className='cursor-pointer text-gray-700 leading-relaxed'
            >
              Acepto emitir los documentos al SII. Al marcar esta casilla, confirmo que he revisado
              todos los documentos y autorizo su emisión mediante mi certificado digital.
            </label>
          </div>

          <div className='flex justify-between mt-6 pt-2 border-t border-gray-200'>
            <button
              type='button'
              onClick={onBack}
              className='btn-detalle-sec'
              disabled={isSubmitting}
            >
              Cancelar
            </button>

            <button
              type='button'
              disabled={!accepted || isSubmitting}
              onClick={handleEmitClick}
              className={`btn-detalle-pri ${!accepted ? 'opacity-50' : ''}`}
            >
              Firmar
            </button>
          </div>
        </div>
      </section>

      <style>
        {`
          .btn-detalle-pri {
            padding: 0.6rem 2.4rem;
            border-radius: 8px;
            background: #000033;
            color: #ffffff;
            font-size: 0.9rem;
            font-weight: 600;
            border: none;
            cursor: pointer;
            transition: all 0.2s;
          }
          .btn-detalle-pri:not(:disabled):hover {
            background: #000055;
            box-shadow: 0 4px 6px rgba(0, 0, 51, 0.2);
          }
          .btn-detalle-pri:disabled {
            cursor: not-allowed;
          }
          
          .btn-detalle-sec {
            padding: 0.6rem 2rem;
            border-radius: 8px;
            background: #ffffff;
            color: #666666;
            font-size: 0.9rem;
            font-weight: 600;
            border: 1px solid #e5e7eb;
            cursor: pointer;
            transition: all 0.2s;
          }
          .btn-detalle-sec:hover {
            background: #f9fafb;
            color: #333333;
          }
        `}
      </style>
    </div>
  )
}
